import { CHECK_STATUS } from '@/constants/dataLayer';
import { actionsTracking } from '@/reducers/tracking/tracking.slice';
import { store } from '@/reducers/store';
import pushDataLayer from './dataLayer';
import validateRecaptcha from './recaptcha';

export const getTrackingInfo = async (
  pickitCode: string,
  retailerToken: string,
  waitForRecaptcha = false,
) => {
  const gRecaptchaToken = await validateRecaptcha(
    process.env.VITE_RECAPTCHA_KEY_V3,
    'submit',
    waitForRecaptcha,
  );
  const recaptchaToken = gRecaptchaToken.toString();
  pushDataLayer({
    ...CHECK_STATUS,
    tracking_id: pickitCode,
  });
  store.dispatch(
    actionsTracking.getTrackingRequest({
      pickitNumber: encodeURIComponent(pickitCode.replace(/\s/g, '')),
      recaptchaToken,
      retailerToken,
    }),
  );
};
